import { GetStaticProps } from "next";
import Head from "next/head";
import SiteChrome from "@chrome/SiteChrome";
import { CanonicalLink } from "@components/head/CanonicalLink";
import { HtmlPageTitle } from "@components/head/HtmlPageTitle";
import { MetaDescription } from "@components/head/MetaDescription";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import BlogPage from "@components/blog/BlogPage";
import { BlogHtmlPageTitle } from "@content/en/blog/HtmlTitle";
import BlogPost, {
  sortBlogPosts,
  extractFeaturedPost,
} from "@components/blog/BlogPost";
import { getAllBlogArticles } from "../../src/scripts/mdx";

type BlogLandingPageProps = {
  featuredPost: BlogPost;
  posts: BlogPost[];
};

const BlogLandingPage = ({ featuredPost, posts }: BlogLandingPageProps) => (
  <SiteChrome noPadding>
    <HtmlPageTitle title={`${BlogHtmlPageTitle} - ${SiteHtmlPageTitle}`} />
    <MetaDescription description="Technical articles about wireless IoT with a focus on Celluar, Wi-Fi, LoRa, and Satellite connectivity provided by Blues Notecard." />
    <CanonicalLink path="/blog" />

    <Head>
      <link
        rel="alternate"
        type="application/rss+xml"
        title={`${BlogHtmlPageTitle} RSS Feed`}
        href="/blog/feed.xml"
      />
    </Head>
    <BlogPage featuredPost={featuredPost} posts={posts} />
  </SiteChrome>
);

export const getStaticProps: GetStaticProps = async () => {
  const articles = await getAllBlogArticles();
  const featuredPost = extractFeaturedPost(articles);

  return {
    props: {
      featuredPost,
      posts: sortBlogPosts(articles),
    },
  };
};

export default BlogLandingPage;
